export default "__VITE_ASSET__CVQdydH3__"